import { render, staticRenderFns } from "./ProjectsPanelSearchResultsTitle.vue?vue&type=template&id=60344b57&"
import script from "./ProjectsPanelSearchResultsTitle.vue?vue&type=script&lang=js&"
export * from "./ProjectsPanelSearchResultsTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports